import React from 'react';
import './Content.css';

const Content = ({ active, setActive }) => {
  let content;

  switch (active) {
    case 'home':
      content = <Home setActive={setActive} />;
      break;
    case 'about':
      content = <About setActive={setActive} />;
      break;
    case 'solutions':
      content = <Solutions setActive={setActive} />;
      break;
    case 'contact':
      content = <Contact />;
      break;
    default:
      content = <Home />;
  }

  return <div className="content">{content}</div>;

};

const Home = ({ setActive }) => {
  const handleLearnMoreClick = () => {
    setActive('about');
  };
  return (
    <div className="content-home">

      <img src="/mould.png" alt="mould" style={{ width: '100%' }} />

      <div class="jumbotron">
        <h1>Specialty Mold Release Agents and Industrial Process Consumables
          <br></br>
          <br></br></h1>
        <h4>Based in Shanghai, we support China-based manufacturers and international suppliers with product selection, technical documentation, sample coordination, customer trials, and market development for mold release agents, lubricants, coatings, and other specialty process consumables.</h4>
        <br></br>
        <p><a class="btn btn-primary btn-lg" href="#about" role="button" onClick={handleLearnMoreClick} id="home-learn-more">Learn more</a></p>
      </div>
    </div>
  );
}

const About = ({ setActive }) => {
  const handleFindSolutionClick = () => {
    setActive('solutions');
  };
  return (
    <div className="content-about">
      <img src="/about-us.png" alt="about-us" style={{ width: '100%' }} />
      <div class="card">
        <div class="card-body">
          <h4 style={{ fontFamily: "Gill Sans", fontSize: "1.5rem" }}> We are a Shanghai-based industrial supply and market-development company focused on specialized process consumables for manufacturing customers in China.
            <br></br>
            <br></br>
            Our experience began in the glass manufacturing supply chain, where reliability, technical fit, and responsive customer support are essential. Building on this foundation, we are expanding into specialty mold release agents for polyurethane, plastics, composites, and other molding-related applications.
            <br></br><br></br>
            We work closely with manufacturers and suppliers to support product selection, technical documentation, sample coordination, customer trials, and long-term supply relationships. Our role is not only to supply products, but to help match the right technical solution with the right industrial application.
            <br></br><br></br>
            From our base in Shanghai, we aim to connect high-quality international specialty chemical suppliers with qualified Chinese manufacturing customers through professional communication, practical application support, and reliable local market development.</h4>
        </div>
        <div class="d-flex justify-content-center" >
          <button type="button" class="btn btn-primary btn-lg btn-block" style={{ width: '30%' }} onClick={handleFindSolutionClick}>Find our solution</button>
        </div>

      </div>
    </div>
  );
}

const Solutions = ({ setActive }) => {
  const handleContactUsButton = (selectedKey) => {
    setActive('contact');

    document.getElementById('contact').classList.add('active');

  };
  return (
    <div className="content-solution">
      <div class="card">
        <img class="card-img-top" src="/perform-bottom.jpg" alt="glass-bottom"></img>
        <div class="card-header">
          <h4>Glass container manufacturing solutions</h4>
        </div>
        <div class="card-header">
          <h5>Butyltin trichloride</h5>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item list-group-item-info">Butyltin trichloride 99%</li>
          <li class="list-group-item ">Butyltin trichloride 95%</li>
          <li class="list-group-item list-group-item-info">Butyltin trichloride 90%</li>
        </ul>
      </div>
      <div className="card mt-4">
        <img className="card-img-top" src="/injection-mould.png" alt="mold-release-agents" />

        <div className="card-header">
          <h4>Specialty Mold Release Agents & Industrial Process Consumables</h4>
        </div>

        <div className="card-body">
          <p>
            We support China-based manufacturers and international suppliers with application-driven product matching, supplier coordination, and market-development services for specialty mold release agents and related process consumables.
          </p>

          <p>
            Our focus includes polyurethane, plastics, composites, glass-related manufacturing, automotive components, and other industrial molding applications where product selection, technical documentation, sample testing, and local customer communication are critical.
          </p>
        </div>

        <div className="card-header">
          <h5>Target Applications</h5>
        </div>

        <ul className="list-group list-group-flush">
          <li className="list-group-item list-group-item-info">Polyurethane molding</li>
          <li className="list-group-item">Plastic molding</li>
          <li className="list-group-item list-group-item-info">Automotive components</li>
          <li className="list-group-item">Composite materials</li>
          <li className="list-group-item list-group-item-info">Mold release and surface treatment</li>
          <li className="list-group-item">Industrial process lubricants and coatings</li>
        </ul>

        <div className="card-header">
          <h5>Our Support</h5>
        </div>

        <ul className="list-group list-group-flush">
          <li className="list-group-item list-group-item-info">Product sourcing and supplier communication</li>
          <li className="list-group-item">TDS / SDS coordination</li>
          <li className="list-group-item list-group-item-info">Sample and trial coordination</li>
          <li className="list-group-item">Quotation support</li>
          <li className="list-group-item list-group-item-info">Technical document translation</li>
          <li className="list-group-item">China market-development support</li>
          <li className="list-group-item list-group-item-info">Local customer communication from Shanghai</li>
        </ul>
      </div>
      <div class="d-flex justify-content-center m-4" >
        <button type="button" class="btn btn-primary btn-lg btn-block" style={{ width: '30%' }} onClick={handleContactUsButton}>Contact Us</button>
      </div>
    </div>
  );
}

const Contact = () => {
  return (
    <div className="content-contact">
      <img src="/glass-pieces.jpg" alt="glass-pieces" style={{ width: '100%' }} />
      <div class="d-flex justify-content-center">
        <img src="/handshake.jpg" alt="handshake" style={{ width: '30%' }} />
        {/* add email info@vueton.com */}
        <div class="d-flex align-items-center ">
          <h5 style={{ fontFamily: "Gill Sans", fontSize: "1.5rem" }} className='ml-3 mr-1'>
            Email us at: {' '}
            <a href="mailto:info@vueton.com"> {'info@vueton.com'}</a>
          </h5>
        </div>
      </div>
    </div>
  );
}

export default Content;
